import { StarIcon } from "@heroicons/react/solid";
import React from "react";
import Separate from "../Separate";

interface Props {
  ticketData: any;
  onClick?: (...args: any[]) => any;
}

const TicketLayout: React.FC<Props> = ({ ticketData, onClick }) => {
  const handleOnChange = (e: any) => {
    if (onClick) {
      onClick(e);
      return e;
    }
    return null;
  };

  return (
    <>
      <div
        className="m-auto mb-5 rounded-lg bg-white p-1 shadow-xl sm:w-80 lg:w-[25rem]"
        onClick={() => handleOnChange(ticketData?._id)}
      >
        <div className="relative flex h-36 justify-center">
          <div className="w-full rounded-tl-lg rounded-bl-lg bg-[#0D7FAC] before:absolute before:left-[-61px] before:h-[40px] before:w-[40px] before:origin-center before:translate-y-[75%] before:translate-x-[50%] before:rotate-45  before:transform before:rounded-[50%] before:rounded-tr-[50%] before:border-[30px] before:border-transparent before:border-t-white before:border-r-white before:content-['']">
            <div className="mb-1 flex items-center justify-center">
              <StarIcon className="mr-2 h-4 w-4 text-gold" />
              <h2 className="text-xl font-bold uppercase">TICKET</h2>
              <StarIcon className="ml-2 h-4 w-4 text-gold" />
            </div>
            <Separate dark={true} />
            <div className="mt-2">
              <h2 className="m-auto w-3/4 text-center text-sm uppercase text-gold">
                {ticketData?.ticketName || "Event Name"}
              </h2>
            </div>
            <div className="m-auto my-2 flex w-fit items-center justify-center bg-black p-1 text-sm">
              <h3 className="text-sm text-white">{ticketData?.eventDate}</h3>
              <p className="ml-2 w-fit rounded-sm bg-gold px-2 text-xs">
                {ticketData?.type}
              </p>
            </div>
            <div className="flex justify-center">
              <h2 className="flex items-baseline text-sm">
                <span className="mr-1 font-bold uppercase">Price:</span> ₹{" "}
                {ticketData?.price}/-
              </h2>
            </div>
          </div>
          <div className="relative px-2">
            <div className="h-full border-l-2 border-dashed before:absolute before:top-[-24px] before:right-[-14px] before:h-[45px] before:w-[45px] before:rotate-[225deg] before:rounded-[50%] before:rounded-tr-[50%] before:border-[23px] before:border-transparent before:border-t-white before:border-l-white before:content-[''] after:absolute after:bottom-[-24px] after:right-[-13px] after:h-[45px] after:w-[45px] after:rotate-45 after:rounded-[50%] after:rounded-tr-[50%] after:border-[23px] after:border-transparent after:border-t-white after:border-l-white after:content-['']"></div>
          </div>

          <div className="h-full w-16 rounded-tr-lg rounded-br-lg bg-black text-white">
            <h2 className="relative right-[26px] top-2 w-max translate-y-[3.5rem] rotate-[270deg] text-sm uppercase text-gold">
              POWERED BY
            </h2>
            <div className="ml-3 flex translate-y-9 rotate-[270deg] items-center text-lg">
              {" "}
              &nbsp;j
              <img
                className="h-4 w-4"
                src="/assets/images/profile/power_by.svg"
                alt=""
              />
              d-e
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TicketLayout;
